export default __webpack_public_path__ + "static/media/acceso-camara-windows-3.39bd9609.svg";